document.querySelectorAll('.reviews-block').forEach(el => {
    const sliderId = el.dataset.sliderId;
    const items = el.querySelector("[data-slider-items]");
    const controls = el.querySelector("[data-slider-controls]");
    tns({
        container: items,
        fixedWidth: 290,
        autoplay: true,
        controls:true,
        controlsContainer: controls,
        autoplayButton: false,
        autoplayTimeout: 5000,
        center: true,
        gutter: 35,
        nav: false,
        loop: true,
        responsive: {
            "768":{
                "fixedWidth": 330,
                gutter: 40
            },
            "992":{
                "fixedWidth": 375,
                gutter: 100
            },
            "1200":{
                "fixedWidth": 360,
                gutter: 120
            }
        }
    });
    el.querySelectorAll(`[data-reviews-block-controls="${sliderId}"]`).forEach(c => {
        c.removeAttribute('aria-label');
    })
});